// Universal auth helpers for ALL roles (super_admin, admin, advertiser, mall_owner).
// Token stored under `fr_token` (overwrites legacy `fr_admin_token`).
import { api } from "@/lib/api";

const TOKEN_KEY = "fr_token";
const USER_KEY = "fr_user";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || localStorage.getItem("fr_admin_token");
}

export function getStoredUser() {
  const raw = localStorage.getItem(USER_KEY) || localStorage.getItem("fr_admin_user");
  return raw ? JSON.parse(raw) : null;
}

export async function login(email, password) {
  const { data } = await api.post("/auth/login", { email, password });
  localStorage.setItem(TOKEN_KEY, data.access_token);
  localStorage.setItem(USER_KEY, JSON.stringify(data.user));
  // legacy
  localStorage.setItem("fr_admin_token", data.access_token);
  localStorage.setItem("fr_admin_user", JSON.stringify(data.user));
  return data.user;
}

export async function register(payload) {
  const { data } = await api.post("/auth/register", payload);
  if (data.access_token) {
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    localStorage.setItem("fr_admin_token", data.access_token);
    localStorage.setItem("fr_admin_user", JSON.stringify(data.user));
  }
  return data;
}

export async function me() {
  const { data } = await api.get("/auth/me");
  localStorage.setItem(USER_KEY, JSON.stringify(data));
  return data;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem("fr_admin_token");
  localStorage.removeItem("fr_admin_user");
}

export function dashboardPathFor(user) {
  if (!user) return "/login";
  if (user.role === "super_admin" || user.role === "admin") return "/admin";
  if (user.role === "advertiser") return "/advertiser";
  if (user.role === "mall_owner") return "/mall-owner";
  return "/";
}

// Backward-compat
export const adminLogin = login;
export const adminMe = me;
export const adminLogout = logout;
